<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('INDEX.form_label_bankName_search') ||
                  '开户银行/账户名称/银行账号 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group slot="reference">
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '' }
export default {
  data() {
    return { form: { ...initForm } }
  },
  mounted() {
    this.query()
  },
  methods: {
    query() {
      this.$emit('query', this.form)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
